import lottie from 'lottie-web';

import { C } from '../core/Element';

export default class Lotties {
  static _lotties = [];

  static init() {
    C.forEach("[data-lottie]", (e) => {
      const lottie = new Lottie(e);
      this._lotties.push(lottie);
    })
  }

  static dispose() {
    this._lotties.forEach(l => l.dispose());
    this._lotties = [];
  }
}

export class Lottie {
  dom;
  json;
  lottie;

  constructor(__container) {
    this.dom = __container;
    this.json = this.parseJson(__container.dataset.lottie);

    if (this.json) {
      this.lottie = lottie.loadAnimation({
        container: __container,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: this.json
      });
    }
  }

  parseJson(data) {
    try {
      return JSON.parse(data);
    } catch (e) {
      return null;
    }
  }

  dispose() {
    if (this.lottie) {
      this.lottie.destroy();
      this.lottie = null;
    }

    this.dom = null;
    this.json = null;
  }
}
